import { c as _c } from "react/compiler-runtime";
import { Form, Formik } from 'formik';
import { useContext } from 'react';
import { OutpostDestinationTypeMetadata } from '../../../../../../../typings/outpost';
import Button from '../../../common/base/Button';
import Divider from '../../../common/base/Divider';
import Loading from '../../../common/base/Loading';
import { Div } from '../../../common/helpers/StyledUtils';
import Modal from '../../../common/Modal';
import { useToasts } from '../../../common/Toast';
import { GlobalContext } from '../../../contexts/GlobalContext';
import { DestinationCreateFields, DestinationFormValues, getCreateDestinationInitialValues, getTopicOptions, submitCreateDestinationForm } from '../utils/outpostForms';
import { useOutpostConfig } from '../OutpostContext';
interface CreateDestinationModalProps {
  tenant_id: string;
  destination_types: OutpostDestinationTypeMetadata[];
  mutateDestinations: () => void;
  onClose: () => void;
}
const CreateDestinationModal: React.FC<CreateDestinationModalProps> = t0 => {
  const $ = _c(22);
  const {
    tenant_id,
    destination_types,
    mutateDestinations,
    onClose
  } = t0;
  const {
    HookdeckAPI
  } = useContext(GlobalContext);
  const {
    addToast
  } = useToasts();
  const {
    config
  } = useOutpostConfig();
  const t1 = config.TOPICS ?? undefined;
  let t2;
  if ($[0] !== t1) {
    t2 = getTopicOptions(t1);
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const topic_options = t2;
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = getCreateDestinationInitialValues({});
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== addToast || $[4] !== mutateDestinations || $[5] !== onClose) {
    t4 = async () => {
      mutateDestinations();
      addToast("success", "Destination created");
      onClose();
    };
    $[3] = addToast;
    $[4] = mutateDestinations;
    $[5] = onClose;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== addToast) {
    t5 = error_message => {
      addToast("error", `Failed to create destination${error_message ? `: ${error_message}` : ""}`);
    };
    $[7] = addToast;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== HookdeckAPI || $[10] !== destination_types || $[11] !== t4 || $[12] !== t5 || $[13] !== tenant_id) {
    t6 = submitCreateDestinationForm({
      HookdeckAPI,
      tenant_id,
      destination_types,
      on_success: t4,
      on_error: t5
    });
    $[9] = HookdeckAPI;
    $[10] = destination_types;
    $[11] = t4;
    $[12] = t5;
    $[13] = tenant_id;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== destination_types || $[16] !== onClose || $[17] !== topic_options) {
    t7 = props => <Form onSubmit={props.handleSubmit}><Modal title="Add new destination" is_submitting={props.isSubmitting} onClose={onClose}>{destination_types.length === 0 ? <Loading /> : <DestinationCreateFields destination_types={destination_types} topic_options={topic_options} />}<Div m={{
          x: -4,
          t: 4,
          b: 3
        }}><Divider /></Div><Div flex={{
          align: "center",
          justify: "flex-end",
          gap: 3
        }} m={{
          b: -1
        }}><Button type="button" onClick={onClose} outline={true}>Cancel</Button><Button icon="save" disabled={props.isSubmitting || !props.isValid || !props.dirty || !props.values.type} type="submit" onClick={() => props.handleSubmit()} primary={true}>Create destination</Button></Div></Modal></Form>;
    $[15] = destination_types;
    $[16] = onClose;
    $[17] = topic_options;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  let t8;
  if ($[19] !== t6 || $[20] !== t7) {
    t8 = <Formik initialValues={t3} onSubmit={t6}>{t7}</Formik>;
    $[19] = t6;
    $[20] = t7;
    $[21] = t8;
  } else {
    t8 = $[21];
  }
  return t8;
};
export default CreateDestinationModal;